<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-06-09 11:00:08
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-06-09 11:42:31
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/views/exhibitionManage/components/editIdentity.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="identityDrawer">
    <el-drawer v-model="drawer" :before-close="handleClose" :direction="direction" :size="size" :title="title">
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="身份名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="身份key" prop="key">
          <el-input v-model="form.key" />
        </el-form-item>
        <el-form-item label="底部名称" prop="bottomName">
          <el-input v-model="form.bottomName" />
        </el-form-item>
        <el-form-item label="头部类型" prop="name">
          <el-radio-group v-model="form.headerType" class="ml-4">
            <el-radio label="img" size="large">背景图</el-radio>
            <el-radio label="color" size="large">纯色</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.headerType == 'color'" label="颜色选择" prop="color">
          <el-color-picker v-model="form.color" />
        </el-form-item>

        <el-form-item v-if="form.headerType == 'img'" label="顶部图片" prop="headerImg">
          <el-upload
            accept=".png,.jpeg,.jpg"
            action="#"
            class="upload-demo"
            :file-list="form.coverList"
            :http-request="upCover"
            :limit="1"
            list-type="picture-card"
            multiple
            :on-error="handleError"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              <em>点击上传图片</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="cardContainer">
        <div
          v-if="form.headerType == 'img'"
          class="cardHeader"
          :style="{
            background: 'url(' + form.headerImg + ')',
            'background-repeat': 'no-repeat',
            'background-size': '100%',
          }"
        ></div>
        <div v-else class="cardHeader" :style="{ backgroundColor: form.color }"></div>
        <div class="cardBottom">{{ form.bottomName }}</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { upLoadImg } from '@/api/active'
  export default defineComponent({
    name: 'editIdentity.vue',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        drawer: false,
        title: '添加身份',
        direction: 'rtl',
        size: '30%',
        formRef: null,
        form: {
          name: '',
          headerType: 'color',
          color: '#ff0000',
          headerImg: '',
          bottomName: '',
          key: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入身份名称' }],
          bottomName: [{ required: true, trigger: 'blur', message: '请输入底部名称' }],
          key: [{ required: true, trigger: 'blur', message: '请输入身份key' }],
          headerType: [{ required: true, trigger: 'change', message: '请选择头部类型' }],
        },
      })
      // 点击关闭
      const handleClose = () => {}

      // 点击打开
      const showEdit = (row) => {
        state.drawer = true
        state.title = '添加身份'
        console.log(state.drawer)
      }

      // 图片相关操作
      // 上传cover
      const upCover = async (e) => {
        let upData = new FormData()
        upData.append('file', e.file)
        const { data } = await upLoadImg(upData)
        state.form.headerImg = data
      }

      const handleError = (err, file) => {
        proxy.$baseMessage(
          `文件[${file.raw.name}]上传失败,文件大小为${_.round(file.raw.size / 1024, 0)}KB`,
          'error',
          'vab-hey-message-error'
        )
      }

      const handleExceed = (files) => {
        proxy.$baseMessage(
          `当前限制选择 ${proxy.limit} 个文件，本次选择了
             ${files.length}
             个文件`,
          'error',
          'vab-hey-message-error'
        )
      }

      const handleRemove = (file, fileList) => {
        state.form.headerImg = ''
      }

      return {
        ...toRefs(state),
        handleClose,
        showEdit,
        upCover,
        handleError,
        handleExceed,
        handleRemove,
      }
    },
  })
</script>
<style lang="scss">
  .identityDrawer {
    .el-drawer__body {
      height: 80vh;
      overflow-y: auto;
    }
  }
</style>
<style lang="scss" scoped>
  .cardContainer {
    width: 400px;
    height: 700px;
    background: #ccc;
    border-radius: 16px;
    margin: 0 auto;
    position: relative;
  }
  .cardHeader {
    width: 100%;
    height: 100px;
    background: red;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  .cardBottom {
    width: 100%;
    height: 100px;
    background: red;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    position: absolute;
    bottom: 0;
    color: #fff;
    text-align: center;
    line-height: 100px;
    font-size: 40px;
  }
</style>
